import { Card } from '@moia-dev/pace-web'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { AreaContent } from '../basics/AreaContent'
import { NoDataState } from '../patterns/NoDataState/NoDataState'
import { PictureConstructionSite } from '../patterns/NoDataState/PictureConstructionSite'

type EmptyStateProps = {
  title: string
  description?: ReactNode
  children?: ReactNode
}

export const MoiaEmptyState = ({
  title,
  description,
  children,
}: EmptyStateProps) => {
  const { t } = useTranslation()

  return (
    <AreaContent>
      <Card
        css={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'center',
        }}
      >
        <div css={{ textAlign: 'center' }}>
          <NoDataState
            title={title}
            description={
              description ? (
                description
              ) : (
                <>
                  {t('patterns_emptyStateDescription')}
                  <br />
                  {t('patterns_emptyStateCallToAction')}
                </>
              )
            }
            picture={<PictureConstructionSite />}
          />
          {children}
        </div>
      </Card>
    </AreaContent>
  )
}
